import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = {
  class: "trezo-card-content",
  id: "recentPropertySlides"
}
const _hoisted_3 = { class: "flex items-center justify-between mb-[8px] mt-[15px]" }
const _hoisted_4 = { class: "text-lg mb-0 text-orange-500" }
const _hoisted_5 = { class: "block relative pt-px ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_6 = { class: "mt-[10px]" }
const _hoisted_7 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_8 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_9 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Recent Property")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: _ctx.modules,
        class: "mySwiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertys, (property) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: property.id,
              class: "bg-white"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "rounded-[5px] h-[112px] bg-cover bg-no-repeat bg-center",
                  style: _normalizeStyle({ backgroundImage: `url(${property.image})` })
                }, null, 4),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, "$" + _toDisplayString(property.price), 1),
                  _createVNode(_component_RouterLink, {
                    to: "/real-estate/property-details",
                    class: "inline-block font-medium text-primary-500 transition-all hover:text-primary-400 hover:underline"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" View More ")
                    ])),
                    _: 1,
                    __: [0]
                  })
                ]),
                _createElementVNode("span", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]" }, " location_on ", -1)),
                  _createTextVNode(" " + _toDisplayString(property.location) + " Prince Consort Road ", 1)
                ]),
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bed ", -1)),
                    _createTextVNode(" " + _toDisplayString(property.bed) + "Bed ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bathtub ", -1)),
                    _createTextVNode(" " + _toDisplayString(property.bath) + "Bath ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " square_foot ", -1)),
                    _createTextVNode(" " + _toDisplayString(property.sqft) + "sqft ", 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
        ]),
        _: 1,
        __: [5]
      }, 8, ["modules"])
    ])
  ]))
}